import React, { useState, useEffect } from "react";
import {
    Box,
    TextField,
    Button,
    Grid,
    InputAdornment,
} from "@mui/material";

import { get } from "src/utils/networkUtils";
/*
const inputStyles = {
    borderRadius: "50px",
    boxShadow: "0.5px 3px 10px 0px #7777771A",
    "& .MuiOutlinedInput-root": {
        borderRadius: "50px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "50px",
        borderColor: "#ccc",
    },
    "& .MuiInputBase-input": {
        color: "#6A707E",
        fontSize: "16px",
        fontWeight: 600,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    "& .MuiInputBase-input::placeholder": {
        color: "#6A707E",
    },
    "& .MuiInputLabel-root": {
        color: "#464A53",
        fontSize: "16px",
        fontWeight: 600,
    },
    width: "217px",
};

const inputFieldStyles = {
    ...inputStyles,
    maxWidth: "163px",
};
*/



const XpAchievmentsContent = () => {
    const handleSave = () => { };
    const handleCancel = () => { };

    /*
    const [, setEditedTeam] = useState({});
     const handleChange = (index, value, setRows, rows, options) => {
        const selected = options.find((o) => o.value === value);
        const newRows = [...rows];
        newRows[index] = { type: value, xp: selected ? selected.xp : 0 };
        setRows(newRows);
    };
    const uploadFiles = (event) => {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            const imageType = event.target.dataset.imageType;
            if (!file || !imageType) return;

            const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
            const maxSize = 2 * 1024 * 1024;

            if (!validTypes.includes(file.type)) {
                alert("Only JPG, JPEG, PNG, and WEBP formats are allowed.");
                event.target.value = null;
                return;
            }

            if (file.size > maxSize) {
                alert("File size should not exceed 2MB.");
                event.target.value = null;
                return;
            }

            const newFileName = file.name.replace(/\s+/g, "_");
            const extension = newFileName.substring(newFileName.lastIndexOf("."));
            const safeFileName = `image_${Date.now()}${extension}`;

            const renamedFile = new File([file], safeFileName, { type: file.type });

            const uploadFilesAsync = async () => {
                try {
                    await createBlobInContainer(renamedFile);
                    const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
                    const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
                    const imageUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${renamedFile.name}`;

                    setEditedTeam((prevTeam) => ({
                        ...prevTeam,
                        [imageType]: imageUrl,
                    }));
                } catch (err) {
                    alert("Error uploading file");
                } finally {
                    event.target.value = null;
                }
            };

            uploadFilesAsync();
        }
    };

    const [badges, setBadges] = useState([
        {
            title: "Bolt to Finish",
            description: "Promoted 3x division in a row",
            xpReward: 500,
            image: null,
        },
    ]);
    */
    const [rewards, setRewards] = useState([]);

    useEffect(() => {
        let mounted = true;

        get(`/admin/reward-types`)
            .then((response) => {
                if (!mounted) return;
                const list = response?.rewardTypes ?? response?.data?.rewardTypes ?? [];
                setRewards(list);
                console.log("-- Rewards fetched and set:", list);
            })
            .catch((err) => {
                console.error("Failed to fetch reward types:", err);
                console.error("Error details:", err.response || err.message || err);
            });

        return () => {
            mounted = false;
        };
    }, []);
    return (
        <Box sx={{ p: 0, textAlign: "left" }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                        <Button variant="outlined" color="secondary" onClick={handleCancel}>
                            Cancel
                        </Button>
                        <Button variant="contained" color="primary" onClick={handleSave}>
                            Save
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <Grid container spacing={2}>
                        {rewards && rewards.length > 0 && rewards.map((reward) => (
                            <>
                                <Grid item xs={9} key={reward.id}>
                                    <TextField
                                        label=""
                                        value={reward.label}
                                        size="small"
                                        disabled={true}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={3} key={reward.id}>
                                    <TextField
                                        label=""
                                        value={reward.points}
                                        size="small"
                                        disabled={false}
                                        fullWidth
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">
                                                <img
                                                    src="/assets/icons/xp-level.svg"
                                                    alt="XP Level"
                                                    width={20}
                                                    height={20}
                                                />
                                            </InputAdornment>,
                                        }}
                                    />
                                </Grid>
                            </>
                        ))}
                    </Grid>
                </Grid>
                <Grid item xs={8}>
                    {/** <BadgesSection
                        badges={badges}
                        setBadges={setBadges}
                        uploadFiles={uploadFiles}
                        inputStyles={inputStyles}
                        inputFieldStyles={inputFieldStyles}
                    /> */}

                </Grid>
            </Grid>
        </Box>
    );
};

export default XpAchievmentsContent;
